import * as React from "react";
import type { SVGProps } from "react";
const SvgPhoneHorn = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M18.88 22A18 18 0 0 1 2 5.18 3.14 3.14 0 0 1 5.12 2h4.23a1 1 0 0 1 .93.63l2.12 5.29a1 1 0 0 1-.4 1.23l-1.84 1.1a10.81 10.81 0 0 0 3.59 3.59l1.1-1.84a1 1 0 0 1 1.23-.41l5.29 2.12a1 1 0 0 1 .63.93v4.23A3.12 3.12 0 0 1 18.88 22ZM5.12 4A1.12 1.12 0 0 0 4 5.12 15.94 15.94 0 0 0 18.94 20 1.11 1.11 0 0 0 20 18.88v-3.56l-3.88-1.55L15 15.69a1 1 0 0 1-1.3.38 12.73 12.73 0 0 1-5.78-5.74A1 1 0 0 1 8.31 9l1.91-1.12L8.67 4H5.12Z"
    />
  </svg>
);
export default SvgPhoneHorn;
